import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from "mobx-react-lite"
import { styled } from '@mui/system';
import {
    Box,
    Button,
    Typography,
} from '@mui/material';
import * as EzDateUtils from 'utils/EzDateUtils'
import * as StringUtils from 'utils/StringUtils'
import { useOrderStore } from 'store/RootProvider'
import FormConst from 'constants/FormConst';

/**
 * 한줄 영역 컴포넌트
 */
const EzRow = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    marginBottom: 3,
});

/**
 * 항목명 
 */
const EzTitle = styled('div')({
    color: 'darkslategray',
    backgroundColor: '#e8e8e8',
    padding: 8,
    textAlign: 'center',
    borderRadius: 4,
    width: '150px'
});
/**
 * 항목 데이터 
 */
const EzContent = styled('div')({
    color: 'darkslategray',
    padding: 8,
    borderRadius: 4,
    flex:1,
});

/*
 * Module - OrderDetail.js
 *
 * Description : 주문 상세 화면입니다. 
 *
 * 작성자 : Choi young ho. 
 * Created on Thu Jun 23 2022
 * Copyright (c) 2022 Renewhouse corp
 */
const OrderDetail = observer( () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const orderStore = useOrderStore();

    const [obj, setObj] = useState(state[0]);


    /**
     * 환불 요청을 
     * 스토어에 요청 합니다. 
     */
    const doRefund = async () => {
        console.log("Try to Refund");
        try {
            let result = await orderStore.reqRefund(obj.payInfoId);

            alert(result?.map['resultMsg']);

            let payInfoResult = await orderStore.getPayInfo(obj.payInfoId);
            const payObj = payInfoResult[FormConst.OBJECT_FIELD];

            console.log("Pay Ob", payObj);
            let newObj = {... obj};
            newObj.cancelDate = payObj.cancelDate;
            newObj.cancelResultMsg = payObj.cancelResultMsg;

            setObj(newObj);
        }
        catch(e) {
            console.log("Error", e);
        }
    }

    return (
        <>
            <Typography variant="h5" color="text.primary" sx={{ mb: 5, mt: 5 }}>결제 상세보기</Typography>
            <EzRow>
                <EzRow>
                    <EzTitle>상점아이디</EzTitle>
                    <EzContent>{obj.ezCompanyId}</EzContent>
                </EzRow>
                <EzRow>
                    <EzTitle>상호</EzTitle>
                    <EzContent>{obj.compName}</EzContent>
                </EzRow>
            </EzRow>
            <EzRow>
                <EzRow>
                    <EzTitle>대표자</EzTitle>
                    <EzContent>{obj.ceoName}</EzContent>
                </EzRow>
                <EzRow>
                    <EzTitle>사업자번호</EzTitle>
                    <EzContent>{obj.compSsn}</EzContent>
                </EzRow>
            </EzRow>
            <EzRow>
                <EzRow>
                    <EzTitle>구매자</EzTitle>
                    <EzContent>{obj.buyername}</EzContent>
                </EzRow>
                <EzRow>
                    <EzTitle>구매자연락처</EzTitle>
                    <EzContent>{obj.buyertel}</EzContent>
                </EzRow>
            </EzRow>
            <EzRow>
                <EzRow>
                    <EzTitle>구매상품</EzTitle>
                    <EzContent>{obj.payItemName}</EzContent>
                </EzRow>
                <EzRow>
                    <EzTitle>구매금액</EzTitle>
                    <EzContent>{obj.payItemPrice}</EzContent>
                </EzRow>
            </EzRow>
            <EzRow>
                <EzRow>
                    <EzTitle>결제결과</EzTitle>
                    <EzContent>{obj.payResultMsg}</EzContent>
                </EzRow>
                <EzRow>
                    <EzTitle>승인번호</EzTitle>
                    <EzContent>{obj.applnum}</EzContent>
                </EzRow>
            </EzRow>
            <EzRow>
                <EzRow>
                    <EzTitle>결제정보</EzTitle>
                    <EzContent>{obj.cardNum}</EzContent>
                </EzRow>
                <EzRow>
                    <EzTitle>결제일자</EzTitle>
                    <EzContent>{EzDateUtils.dateFormatting(obj.payRequestDate)}</EzContent>
                </EzRow>
            </EzRow>
            <EzRow>
                <EzRow>
                    <EzTitle>취소결과</EzTitle>
                    <EzContent>{obj.cancelResultMsg}</EzContent>
                </EzRow>
                <EzRow>
                    <EzTitle>취소일자</EzTitle>
                    <EzContent>{EzDateUtils.dateFormatting(obj.cancelDate)}</EzContent>
                </EzRow>
            </EzRow>
            <EzRow>
                <EzRow>
                    <EzTitle>취소결과코드</EzTitle>
                    <EzContent>{obj.cancelResultCode}</EzContent>
                </EzRow>
                <EzRow>
                    <EzTitle>취소결과상세코드 </EzTitle>
                    <EzContent>{obj.cancelDetailResultCode}</EzContent>
                </EzRow>
            </EzRow>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant="outlined"
                    sx={{ ml: 2 }}
                    onClick={() => { doRefund() }}
                >
                    결제취소
                </Button>
                <Button
                    variant="outlined"
                    sx={{ ml: 2 }}
                    onClick={() => { navigate(-1) }}
                >
                    목록으로
                </Button>
            </Box>
        </>
    );
})

export default OrderDetail;